import { inject, observer } from "mobx-react";

import "./information.scss";

import LoadedComponent from "../LoadedComponent/index";
import Main from "./main";
import Documents from "./documents";

const Information = ({
  openFiles,
  openFilesInProfile,
  cleanFilesSuccess,
  isLoading,
  newData
}) => {
  return (
    <div className="information">
      <div className="information__labels">
        <p
          className={`${
            openFiles
              ? "information__labels-darklabel"
              : "information__labels-lightlabel"
          }`}
          onClick={() => {
            openFilesInProfile(false);
            cleanFilesSuccess();
          }}
        >
          Основная информация
        </p>
        <p
          className={`${
            openFiles
              ? "information__labels-lightlabel"
              : "information__labels-darklabel"
          }`}
          onClick={() => {
            openFilesInProfile(true);
            cleanFilesSuccess();
          }}
        >
          Мои документы
        </p>
      </div>
      <LoadedComponent isLoading={isLoading}>
        {!openFiles ? (
          <Main newData={newData} />
        ) : (
          <Documents newData={newData} />
        )}
      </LoadedComponent>
    </div>
  );
};

export default inject(({ usersStore, filesStore }) => {
  const { openFiles, openFilesInProfile, cleanFilesSuccess } = filesStore;
  const { isLoading } = usersStore;

  return {
    openFiles,
    openFilesInProfile,
    cleanFilesSuccess,
    isLoading
  };
})(observer(Information));
